import { useEffect, useRef, useState } from 'react';

export const latestDiscountVersions = (versions, key) => Object.values(versions.reduce((result, version) => (
  !result[version[key]] || result[version[key]].version < version.version ? { ...result, [version[key]]: version } : result
), {}));

export const discountToday = () => {
  const date = new Date();
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
};

export function useDiscountPolicy(load, enabled) {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const alive = useRef(true);
  const lock = useRef(false);
  const command = useRef(null);
  const reload = async () => {
    if (lock.current) return;
    lock.current = true; setBusy(true);
    try {
      const result = await load();
      if (alive.current) {
        setData(result); setError('');
        if (error === 'conflict') command.current = null;
      }
    } catch (err) { if (alive.current) setError('error'); } finally { lock.current = false; if (alive.current) setBusy(false); }
  };
  useEffect(() => {
    alive.current = true;
    if (enabled) reload();
    return () => { alive.current = false; };
  }, [enabled]);
  const save = async (method, payload) => {
    if (lock.current || ['conflict', 'refresh', 'alreadyUsed'].includes(error)) return false;
    const serialized = JSON.stringify({ ...payload, expectedRevision: undefined });
    if (!command.current || command.current.serialized !== serialized) {
      command.current = { serialized, payload, requestId: `${Date.now()}-${Math.random().toString(36).slice(2)}` };
    }
    lock.current = true; setBusy(true); setError('');
    try {
      await method({ ...command.current.payload, requestId: command.current.requestId });
      command.current = null;
      try {
        const result = await load();
        if (alive.current) setData(result);
      } catch (err) { if (alive.current) setError('refresh'); }
      return true;
    } catch (err) {
      if (alive.current) {
        let message = Number(err.status || err.statusCode || err.code) === 409 ? 'conflict' : 'error';
        if (err.message === 'DISCOUNT_ALREADY_USED') message = 'alreadyUsed';
        setError(message);
      }
      return false;
    } finally { lock.current = false; if (alive.current) setBusy(false); }
  };
  return { data, busy, error, reload, save };
}
